import { LOCATION_FIX_RECEIVED, CLEAR_LOCATION_FIX } from "./actionTypes";

/**
 * Session-scoped location store — DELIBERATELY NOT PERSISTED (it is not in
 * the root persist whitelist, see src/store/index.js). Anything read from it
 * was observed by the running process, never restored from disk, so a cold
 * start can't hand back yesterday's position looking like a live one.
 *
 * Holds only the most recent fix, from either source:
 *   - "stream"  — movex.geo background tracking (MovexGeo.onLocations)
 *   - "capture" — a one-shot captureCurrentPosition taken by a screen
 *
 * Out-of-order fixes are dropped: writes are guarded on `updated_at`.
 * Same shape and rules as the partner-db app's slice.
 */
export const actions = {
  /** @param payload {{latitude, longitude, accuracy?, source?}} */
  locationFixReceived: ({ latitude, longitude, accuracy, source }) => ({
    type: LOCATION_FIX_RECEIVED,
    payload: {
      latitude,
      longitude,
      accuracy: accuracy ?? null,
      source: source ?? "stream",
      // Stamped at action-creation so the reducer stays pure.
      updated_at: new Date().toISOString(),
    },
  }),
  clearLocationFix: () => ({ type: CLEAR_LOCATION_FIX }),
};

const initialState = { lastFix: null };

const isNewer = (incoming, current) => {
  if (!current?.updated_at) return true;
  return new Date(incoming.updated_at) >= new Date(current.updated_at);
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_FIX_RECEIVED: {
      const fix = action.payload;
      if (fix?.latitude == null || fix?.longitude == null) return state;
      if (!isNewer(fix, state.lastFix)) return state;
      return { ...state, lastFix: fix };
    }
    case CLEAR_LOCATION_FIX:
      return { ...state, lastFix: null };
    default:
      return state;
  }
};
reducer.initialState = initialState;
export default reducer;
